import React from 'react';



import { useChartRef } from "../../context";
import useChartOptions from "../../hooks/useChartOptions";
import useIndicator from "../../hooks/useIndicator";
import useQuote from "../../hooks/useQuote";
import useStockCode from "../../hooks/useStockCode";
import WebChartReact from "../../submodules/wcr-gachinet"
import {useChartStockCode} from "../../../@shared/stores/chartStore";
import {usePartenerTradeStrategy} from "../../../@shared/stores/partnerStore";
import "@shared/assets/styles/chart.css"

export default function Chart() {
  const { chartRef } = useChartRef()
  const { indicator } = useIndicator()
  const {
    option: { period, minutes },
  } = useChartOptions()
  const code = useStockCode()
  const quote = useQuote()
  const {stockCode, stockPrice} = useChartStockCode();
  const {isOpenTradeStrategy} = usePartenerTradeStrategy()
  const padding = isOpenTradeStrategy ? 270 : 45

  const windowHeight = window.innerHeight

  return (
    <div
      id="chart-container"
      style={{
        position: 'relative',
        // width: 'calc(100% - 40px)',
        // height: windowHeight - 68 - 68 - 80,
        height: windowHeight - 68 - 68 - 80 - padding, // 68(header) + 68(stockInfo) + 80(stockInfo) + 270(종목전략)
        // height: '100%'
      }}
    >
      <WebChartReact
        chartRef={chartRef}
        globalOptions={{
          navigation: {
            bindingsClassName: 'tools-container',
          },
          stockTools: {
            gui: {
              enabled: false,
            },
          },
        }}
        reflow={{}}
        indicators={{
          sma: indicator.disableSma ? indicator.sma.map((sma) => ({
            ...sma,
            visible: false,
          })) : indicator.sma,
          vsma: indicator.disableVsma
            ? indicator.vsma.map((vsma) => ({
                ...vsma,
                visible: false,
              }))
            : indicator.vsma,
          volume: {
            visible: true,
          },
          volumePrice: {
            visible: true,
          },
        }}
        code={code || stockCode}
        period={period}
        unit={minutes}
        availablePeriods={['days', 'weeks', 'minutes']}
        availableMinuteUnits={[1, 5, 10, 60]}
        api={{
          baseUrl: '//quot-api.stockplus.com',
          candlePath: '/v1/candle',
        }}
        quote={quote}
        isMobile={false}
        stockPrice={Number(stockPrice)}
      />
    </div>
  )
}
